import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";

import { db } from "../../../config/firebase";
import { COLLECTION } from "../../../data/constant";
import { collection, query, where, getDocs } from "firebase/firestore";

const UserViewDisputeModal = ({ open, onClose, transaction }) => {
  const [disputes, setDisputues] = useState([]);

  useEffect(() => {
    if (!transaction) return;

    const load = async () => {
      try {
        const q = query(
          collection(db, COLLECTION.TRANSACTION_DISPUTES),
          where("transactionID", "==", transaction.transactionid || transaction.id)
        );

        const snapshot = await getDocs(q);

        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setDisputues(list);
      } catch (err) {
        console.error("Error loading disputes:", err);
      }
    };

    load();
  }, [transaction]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Dispute History</DialogTitle>

      <DialogContent
        style={{
          maxHeight: "70vh",     // ✅ prevents vertical overflow
          overflowY: "auto",     // ✅ enable scroll
          paddingRight: "10px",  // optional: avoids scrollbar overlap
        }}
      >
        {disputes.length === 0 ? (
          <Typography>No disputes found for this transaction.</Typography>
        ) : (
          disputes.map((d) => (
            <div key={d.id} style={{ marginBottom: 25 }}>
              <Typography><strong>Issue:</strong> {d.issueDescription}</Typography>

              <Typography>
                <strong>Status:</strong>{" "}
                {d.status === "active" ? (
                  <span style={{ color: "red" }}>Active</span>
                ) : (
                  <span style={{ color: "green" }}>Resolved</span>
                )}
              </Typography>

              {d.resolutionDescription && (
                <Typography>
                  <strong>Admin Response:</strong> {d.resolutionDescription}
                </Typography>
              )}

              <Typography style={{ fontSize: 12, opacity: 0.7 }}>
                {new Date(d.createdAt).toLocaleString()}
              </Typography>

              <hr style={{ marginTop: 10 }} />
            </div>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UserViewDisputeModal;
